// @flow
import React from 'react';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { Link } from 'react-router-dom';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Tag } from '@finect/tabular-components/Tags';
import { Section } from '@finect/tabular-components/Section';
import { SkeletonLine } from '@finect/tabular-components/Skeleton';
import { ProvincesContainer } from './partials';

type Props = {
  staticContext?: Object,
  full?: boolean,
  provinces?: Array<Object>
};

type State = {
  provinces: Array<Object>
};

export class Provinces extends React.Component<Props, State> {
  state =
    typeof window === 'undefined'
      ? { provinces: this.props.provinces || this.props.staticContext?.initialData.provinces || [] }
      : { provinces: this.props.provinces || window.initialData?.provinces || [] };

  componentDidMount() {
    if (!this.state.provinces.length) {
      Provinces.loadInitialData().then(provinces =>
        this.setState({
          provinces: provinces || []
        }));
    }
  }

  static loadInitialData() {
    return finectAPI({
      version: 'v4',
      path: 'bff/advisors/provinces',
      method: 'GET',
      onSuccess: (provinces: Object) =>
        provinces.data.map(province => ({
          ...province,
          // delete whats after '/' in slug
          province: province.province.split('/')[0]
        })),
      onError: () => console.log('Request to provinces failed!'), // eslint-disable-line
    });
  }

  render() {
    return (
      <Section title="Asesores financieros por provincia">
        {this.state.provinces.length > 0 ? null : <SkeletonLine style={{ width: '100%', height: '160px' }} />}
        <ProvincesContainer>
          {[...this.state.provinces].sort((a, b) => a.province.localeCompare(b.province, 'es')).map(province => (
            <li key={province.code}>
              <Tag key={province.code} withMargin data-fi-event="home-provinces">
                <AppLink
                  as={Link}
                  data-fi-event="home-provinces"
                  to={`/asesores/encuentra-un-asesor/en/${province.slug}`}
                  title={`Asesores financieros en la provincia de ${province.province}`}
                >
                  {province.province}
                </AppLink>
              </Tag>
            </li>
          ))}
        </ProvincesContainer>
      </Section>
    );
  }
}
